module.exports = __webpack_public_path__ + "static/media/table-bg.bbcec0d6.svg";